"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapperManager = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const api_1 = require("../api");
function validateSwapper(swapper) {
    if (!(typeof swapper === 'object' && typeof swapper.getType === 'function'))
        throw new api_1.SwapError('[validateSwapper] - invalid swapper instance', {
            code: api_1.SwapErrorTypes.MANAGER_ERROR
        });
}
// TODO: remove me
class SwapperManager {
    constructor() {
        this.swappers = new Map();
    }
    /**
     *
     * @param swapperType swapper type {SwapperType|string}
     * @param swapperInstance swapper instance {Swapper}
     * @returns {SwapperManager}
     */
    addSwapper(swapperType, swapperInstance) {
        const swapper = this.swappers.get(swapperType);
        if (swapper)
            throw new api_1.SwapError('[addSwapper] - swapper already exists', {
                code: api_1.SwapErrorTypes.MANAGER_ERROR,
                details: { swapperType }
            });
        validateSwapper(swapperInstance);
        this.swappers.set(swapperType, swapperInstance);
        return this;
    }
    /**
     *
     * @param swapperType swapper type {SwapperType|string}
     * @returns {Swapper}
     */
    getSwapper(swapperType) {
        const swapper = this.swappers.get(swapperType);
        if (!swapper)
            throw new api_1.SwapError('[getSwapper] - swapperType doesnt exist', {
                code: api_1.SwapErrorTypes.MANAGER_ERROR,
                details: { swapperType }
            });
        return swapper;
    }
    /**
     *
     * @param swapperType swapper type {SwapperType|string}
     * @returns {SwapperManager}
     */
    removeSwapper(swapperType) {
        const swapper = this.swappers.get(swapperType);
        if (!swapper)
            throw new api_1.SwapError('[removeSwapper] - swapperType doesnt exist', {
                code: api_1.SwapErrorTypes.MANAGER_ERROR,
                details: { swapperType }
            });
        this.swappers.delete(swapperType);
        return this;
    }
    async getBestSwapper(args) {
        // TODO: This will eventually have logic to determine the best swapper.
        // For now we return the first swapper we get from getSwappersByPair
        return this.getSwappersByPair(args)[0];
    }
    /**
     *
     * @param pair type {GetQuoteInput}
     * @returns {SwapperType}
     */
    getSwappersByPair(pair) {
        const { sellAssetId, buyAssetId } = pair;
        return Array.from(this.swappers.values()).filter((swapper) => swapper.filterBuyAssetsBySellAssetId({ sellAssetId, assetIds: [buyAssetId] }).length);
    }
    getSupportedBuyAssetIdsFromSellId(args) {
        return (0, uniq_1.default)(Array.from(this.swappers.values()).flatMap((swapper) => swapper.filterBuyAssetsBySellAssetId(args)));
    }
    getSupportedSellableAssetIds(args) {
        const { assetIds } = args;
        return (0, uniq_1.default)(Array.from(this.swappers.values()).flatMap((swapper) => swapper.filterAssetIdsBySellable(assetIds)));
    }
}
exports.SwapperManager = SwapperManager;
